import { API_URL } from "env";
import { mixLogOut } from '../services/mixin';
import type { MessageCreator } from './ChannelMessage';

export interface ChannelCommentItem {
    id: number;
    channel_connection_id?: number;
    channel_customer_id?: number;
    external_post_id?: string | null;
    external_comment_id?: string | null;
    external_parent_id?: string | null;
    direction: "inbound" | "outbound";
    text: string;
    payload?: any;
    sent_at: string;
    /** Nhân viên trả lời bình luận từ CMS (null nếu không xác định được) */
    created_by_id?: number | null;
    creator?: MessageCreator | null;
    staff_name?: string | null;
}

export interface ChannelCommentListResponse {
    status: boolean;
    data: {
        items: ChannelCommentItem[];
        total: number;
        current_page?: number;
    } | null;
}

// Lịch sử bình luận của 1 khách hàng theo kênh
export async function getChannelComments(params: {
    customer_id: number;
    page?: number;
    sort?: string[];
}): Promise<ChannelCommentListResponse> {
    try {
        const token = localStorage.getItem('token') || '';
        const query = new URLSearchParams();
        query.append('customer_id', String(params.customer_id));
        if (params.page) query.append('page', String(params.page));
        (params.sort && params.sort.length ? params.sort : ['sent_at,asc']).forEach(s => query.append('sort[]', s));

        const response = await fetch(`${API_URL}/api/v1/be/channel-comments?${query.toString()}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });
        if (!response.ok) {
            if (response.status === 401) { mixLogOut(); }
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.json() as ChannelCommentListResponse;
    } catch (error) {
        console.error('Failed to fetch channel comments:', error);
        return { status: false, data: null };
    }
}

export interface ReplyChannelCommentResponse {
    status: boolean;
    data: ChannelCommentItem | null;
    msg?: string;
}

// Trả lời bình luận (Admin Reply) -> đăng bình luận con lên Facebook
export async function replyChannelComment(params: {
    customer_id: number;
    parent_comment_id: string;
    text: string;
}): Promise<ReplyChannelCommentResponse> {
    try {
        const token = localStorage.getItem('token') || '';
        const response = await fetch(`${API_URL}/api/v1/be/channel-comment`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(params),
        });
        const json = await response.json().catch(() => ({}));
        if (!response.ok) {
            if (response.status === 401) { mixLogOut(); }
            return { status: false, data: null, msg: json?.msg };
        }
        return { status: json?.status ?? true, data: json?.data ?? null, msg: json?.msg };
    } catch (error) {
        console.error('Failed to reply channel comment:', error);
        return { status: false, data: null };
    }
}
